import { Component, OnInit } from '@angular/core';
import {NgRedux} from '@angular-redux/store';
import {canHide} from '../../shared/helpers';
import {FeatureToggleEntries} from '../../shared/feature-toggle-settings-enum';
import {IAppState} from '../../store/IAppState';

@Component({
  selector: 'app-denials-base',
  templateUrl: './denials-base.component.html',
  styleUrls: ['./denials-base.component.scss']
})
export class DenialsBaseComponent implements OnInit {
  canHideMultiLevel = false;

  constructor(private ngRedux: NgRedux<IAppState>) { }

  ngOnInit(): void {
    const {featureToggleSettings, userProfile} = this.ngRedux.getState().data;
    this.canHideMultiLevel = canHide(FeatureToggleEntries.DENIALS_ONTOLOGY, featureToggleSettings, userProfile);
  }

}
